var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticClass: "wrapper d-flex align-center justify-start",
    attrs: {
      "color": "transparent",
      "height": "100px",
      "flat": "",
      "width": "100%"
    }
  }, 'v-card', _vm.link, false), [_c('v-card', {
    staticClass: "background d-flex align-center justify-space-between",
    class: ((_vm.secondaryColor) + "--text"),
    attrs: {
      "color": _vm.primaryColor,
      "hover": "",
      "rounded": "",
      "height": "100%",
      "width": "90%"
    }
  }), _c('v-card', {
    staticClass: "content-container d-flex align-center justify-center",
    attrs: {
      "color": "transparent",
      "flat": ""
    }
  }, [_c('v-sheet', {
    staticClass: "media-container d-flex align-center justify-center",
    attrs: {
      "color": "yellow",
      "height": "90%",
      "rounded": ""
    }
  }, [_vm.image ? _c('v-img', {
    staticClass: "rounded-lg",
    attrs: {
      "contain": "",
      "height": "auto",
      "src": _vm.image,
      "width": "100%"
    }
  }) : _vm.icon ? _c('v-icon', {
    attrs: {
      "color": _vm.secondaryColor,
      "large": ""
    }
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e()], 1), _c('v-card-text', {
    staticClass: "content d-flex align-center justify-start"
  }, [_c('v-sheet', {
    staticClass: "cardTitle font-weight-black text-wrap mr-auto",
    class: ((_vm.secondaryColor) + "--text"),
    attrs: {
      "color": "transparent"
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }